import changeTracker from "../utils/change-tracker";
import { v } from "framework";

export default {
    data() {
        return {
            validationMessage: null
        }
    },
    props: {
        columns: {
          type: Number,
          default: 1,
          validator: function (value) {
              let validNumberOfColumns = [1,2,3,4,5,6,7,8,9,10,11,12];
              return (validNumberOfColumns.indexOf(value) !== -1);
          }
        },
        noTracking: Boolean,
        disabled: Boolean,
        showLabel: {
            type: Boolean,
            required: false,
            default: null
        },
        validator: Object,
        autofocus: Boolean,
    },
    created() {
        if (this.validator && this.validator.$dirty) {
            this.updateValidationMessage();
        }
    },
    mounted() {
        if (!this.$_showLabel) {
            this.$el.classList.add("no-top-label");
        }

        if(this.$_autofocus)
        {
            let input = this.$el.querySelector('[autofocus]');
            if (input) {
                input.focus();
            }
        }
    },
    computed: {
        $_disabled() {
            if (this.getParentProperty("readOnly", false)) return true;
            return this.disabled;
        },
        $_showLabel() {
            if(!this.label) return false;
            if (this.showLabel !== null) return this.showLabel;
            var parentShowLabel = this.getParentProperty("showLabel");
            if (_.isBoolean(parentShowLabel)) return parentShowLabel;
            return true;
        },
        hasError() {
            return Boolean(this.validationMessage);
        },
        placeholder() {
            return this.$_showLabel ? null : (this.label || null)
        },
        $_autofocus()
        {
            return this.autofocus;
        },
        primitiveBaseClasses() {
            return {
                'amf-primitive': this.useAmfPrimitiveClass,
                'two-column': this.layoutTwoColumn,
                'three-column': this.layoutThreeColumn,
                'four-column': this.layoutFourColumn,
                'twelve-column': this.layoutTwelveColumn,
                one: this.columns === 1,
                two: this.columns === 2,
                three: this.columns === 3,
                four: this.columns === 4,
                five: this.columns == 5,
                six: this.columns == 6,
                seven: this.columns == 7,
                eight: this.columns == 8,
                nine: this.columns == 9,
                ten: this.columns == 10,
                eleven: this.columns == 11,
                twelve: this.columns == 12
            };
        },
        layoutTwoColumn() {
            return this.getAmfOption('layout') === 'two-column';
        },
        layoutThreeColumn() {
          return this.getAmfOption('layout') === 'three-column' || !this.getAmfOption("layout") || !this.getAmfOption("layout").includes("-column");
        },
        layoutFourColumn() {
            return this.getAmfOption('layout') === 'four-column';
        },
        layoutTwelveColumn() {
            return this.getAmfOption('layout') === 'twelve-column';
        },
        useAmfPrimitiveClass() {
            return !(this.getAmfOption("layout") === "custom");
        }
    },
    watch: {
        validator: {
            handler() {
                this.updateValidationMessage();
            },
            deep: true
        }
    },
    methods: {
        updateValidationMessage() {
            if(this.validator && this.validator.$dirty) {
                this.validationMessage = v.getMessage(this.validator);
            }
        },
        changeMade(changeData) {
            if (this.getAmfOption("noTracking")) return;
            if (!this.noTracking) {
                changeData = changeData || {}; 
                changeData.component = this;
                changeTracker.changeMade(changeData);
            }
        },
        getAmfOption(optionName, component) {
            component = component || this;
            if (component.amfOptions && component.amfOptions[optionName]) {
                return component.amfOptions[optionName];
            }
            if (component.$parent) {
                return this.getAmfOption(optionName, component.$parent);
            }
        },
    }
}




// WEBPACK FOOTER //
// ./src/framework/primitives/primitive-mixin.js